import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Routes, CanActivate } from '@angular/router';

import { UserRouteAccessService } from '../../shared';
import { PaginationUtil } from 'ng-jhipster';

import { MarketplaceComponent } from './marketplace.component';
import { MarketplaceDetailComponent } from './marketplace-detail.component';
import { MarketplacePopupComponent } from './marketplace-dialog.component';
import { MarketplaceDeletePopupComponent } from './marketplace-delete-dialog.component';

import { Principal } from '../../shared';

@Injectable()
export class MarketplaceResolvePagingParams implements Resolve<any> {

  constructor(private paginationUtil: PaginationUtil) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
      const page = route.queryParams['page'] ? route.queryParams['page'] : '1';
      const sort = route.queryParams['sort'] ? route.queryParams['sort'] : 'id,asc';
      return {
          page: this.paginationUtil.parsePage(page),
          predicate: this.paginationUtil.parsePredicate(sort),
          ascending: this.paginationUtil.parseAscending(sort)
    };
  }
}

export const marketplaceRoute: Routes = [
  {
    path: 'marketplace',
    component: MarketplaceComponent,
    resolve: {
      'pagingParams': MarketplaceResolvePagingParams
    },
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.marketplace.home.title'
    },
    canActivate: [UserRouteAccessService]
  }, {
    path: 'marketplace/:id',
    component: MarketplaceDetailComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.marketplace.home.title'
    },
    canActivate: [UserRouteAccessService]
  }
];

export const marketplacePopupRoute: Routes = [
  {
    path: 'marketplace-new',
    component: MarketplacePopupComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.marketplace.home.title'
    },
    canActivate: [UserRouteAccessService],
    outlet: 'popup'
  },
  {
    path: 'marketplace/:id/edit',
    component: MarketplacePopupComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.marketplace.home.title'
    },
    canActivate: [UserRouteAccessService],
    outlet: 'popup'
  },
  {
    path: 'marketplace/:id/delete',
    component: MarketplaceDeletePopupComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.marketplace.home.title'
    },
    canActivate: [UserRouteAccessService],
    outlet: 'popup'
  }
];



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/marketplace/marketplace.route.ts